/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_KidsInputs */

const en_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kids`)
};

const es_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niños`)
};

const fr_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enfants`)
};

const de_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinder`)
};

const ja_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キッズ`)
};

const zh_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`童装`)
};

const ar_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطفال`)
};

const id_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anak-anak`)
};

const it_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bambini`)
};

const ru_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детям`)
};

const pt_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infantil`)
};

const ko_val_kids = /** @type {(inputs: Val_KidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아동용`)
};

/**
* | output |
* | --- |
* | "Kids" |
*
* @param {Val_KidsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_kids = /** @type {((inputs?: Val_KidsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_KidsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_kids(inputs)
	if (locale === "es") return es_val_kids(inputs)
	if (locale === "fr") return fr_val_kids(inputs)
	if (locale === "de") return de_val_kids(inputs)
	if (locale === "ja") return ja_val_kids(inputs)
	if (locale === "zh") return zh_val_kids(inputs)
	if (locale === "ar") return ar_val_kids(inputs)
	if (locale === "id") return id_val_kids(inputs)
	if (locale === "it") return it_val_kids(inputs)
	if (locale === "ru") return ru_val_kids(inputs)
	if (locale === "pt") return pt_val_kids(inputs)
	return ko_val_kids(inputs)
});